import { t } from "../i18n";
import { ChevronRight } from "lucide-react";
import type { IntegrationDefinition } from "../pages/integrations/IntegrationsPage.utils";
import { iconFor } from "../pages/integrations/IntegrationsPage.utils";

export function PickerCard({
  definition,
  onChoose,
}: {
  definition: IntegrationDefinition;
  onChoose: () => void;
}) {
  return (
    <button
      type="button"
      className="group panel flex min-h-40 flex-col items-start p-4 text-left transition hover:-translate-y-0.5 hover:border-lumen-400 hover:shadow-md dark:hover:border-lumen-600"
      onClick={onChoose}
    >
      <div className="mb-3 flex w-full items-start justify-between gap-3">
        <span className="grid size-10 place-items-center rounded-xl bg-lumen-50 text-lumen-700 dark:bg-lumen-950/50 dark:text-lumen-300">
          {iconFor(definition.kind, 20)}
        </span>
        <ChevronRight
          className="text-stone-300 transition group-hover:translate-x-0.5 group-hover:text-lumen-600"
          size={18}
        />
      </div>
      <h4 className="font-bold">{definition.label}</h4>
      <p className="mt-1 flex-1 text-sm leading-5 text-stone-500">
        {definition.description}
      </p>
      <div className="mt-3">
        <p className="mb-1 text-[10px] font-bold tracking-wider text-stone-400 uppercase">
          {t("Unlocks")}
        </p>
        <p className="text-xs font-medium text-stone-600 dark:text-stone-300">
          {definition.capabilities
            .map((capability) => capability.label)
            .join(" · ")}
        </p>
      </div>
      <div className="mt-3 text-xs font-semibold text-lumen-700 dark:text-lumen-300">
        {t("Set up connection")}
        <ChevronRight className="inline" size={13} />
      </div>
    </button>
  );
}
